import { render, staticRenderFns } from "./jiyang_settlement.vue?vue&type=template&id=48a379b5&scoped=true&"
import script from "./jiyang_settlement.vue?vue&type=script&lang=js&"
export * from "./jiyang_settlement.vue?vue&type=script&lang=js&"
import style0 from "./jiyang_settlement.vue?vue&type=style&index=0&id=48a379b5&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48a379b5",
  null
  
)

export default component.exports